/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeAddTermRequest, serializeDeleteTermRequest, serializeOk, type AddTermRequest, type DeleteTermRequest, type ErrorResponse, type Ok } from '../../../models/index.js';
// @ts-ignore
import { ReorderRequestBuilderRequestsMetadata, type ReorderRequestBuilder } from './reorder/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/terms
 */
export interface TermsRequestBuilder extends BaseRequestBuilder<TermsRequestBuilder> {
    /**
     * The reorder property
     */
    get reorder(): ReorderRequestBuilder;
    /**
     * Removes a payment term from the organization's list, matched case-insensitively. Customers, carts, and orders already carrying the value keep it — this only curates the picker options. Removing a term that is not on file is a no-op that still returns 200.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     delete(body: DeleteTermRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Adds a payment term to the organization's list, which reps pick from for customers and carts. Free-form — common values are NET15, NET30, NET45, NET60, NET90, NET120, CREDIT, CASH, COD, and PREPAID, but any custom term (e.g. "2% 10 NET 30") is accepted. The domain trims the value, keeps the casing first typed, and adding a term already on file (any casing) is a no-op that still returns 200.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     post(body: AddTermRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Removes a payment term from the organization's list, matched case-insensitively. Customers, carts, and orders already carrying the value keep it — this only curates the picker options. Removing a term that is not on file is a no-op that still returns 200.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteTermRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Adds a payment term to the organization's list, which reps pick from for customers and carts. Free-form — common values are NET15, NET30, NET45, NET60, NET90, NET120, CREDIT, CASH, COD, and PREPAID, but any custom term (e.g. "2% 10 NET 30") is accepted. The domain trims the value, keeps the casing first typed, and adding a term already on file (any casing) is a no-op that still returns 200.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddTermRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TermsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/terms";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TermsRequestBuilderNavigationMetadata: Record<Exclude<keyof TermsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    reorder: {
        requestsMetadata: ReorderRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const TermsRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: TermsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteTermRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    post: {
        uriTemplate: TermsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddTermRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
